
import Vue from "vue";
import AppFileUpload from "@/components/FileUpload.vue";
import { InboxUpload } from "@/utils/inbox/inbox-upload-job";
import { HttpError } from "@/utils/services/http-error";
import { AuthService, DossierConfigService } from "@/services";
import { MODULE } from "@/config/modules";
import { InboxreaderService } from "@/services/inboxreader-service";
import { TranslateResult } from "vue-i18n";

const MAX_FILES = 20;

export default Vue.extend({
	data(){
		return {
			// Shared, so the upload stays visible after a tab or route change.
			uploadJob: InboxUpload,
			purchaseConfig: DossierConfigService.getPurchaseConfig(),
			selection: [] as File[],
			dragDepth: 0,
			mailboxAlias: "",
			allowedExtensions: ["pdf", "jpg", "jpeg", "png"],
			maxSize: 15e6
		};
	},
	computed: {
		uploading():boolean{
			return this.uploadJob.uploading;
		},
		sending():boolean{
			return this.uploadJob.isSending;
		},
		dragging():boolean{
			return this.dragDepth > 0 && !this.uploading;
		},
		// Uploading works for everyone, mailing documents in needs the module
		// and the mailbox switched on.
		showMailAddress():boolean{
			if (!AuthService.hasModule(MODULE.INKOMENDE_AANKOPEN_UIT_MAILBOX)) return false;
			return this.purchaseConfig.PurchasesFromInboxreaderEnabled;
		},
		mailAddress():string{
			if (this.mailboxAlias) return `${this.mailboxAlias}@winfakt.app`;
			return `dossier_${AuthService.wfDossier.id}@winfakt.app`;
		},
		uploadTitle():TranslateResult{
			if (this.uploadJob.isSending) return this.$ct("uploading-percent", {percent: this.uploadJob.uploadPercent});
			return this.$ct("analyzing-documents");
		},
		uploadFooter():TranslateResult{
			return this.$ct("x-of-y-done", {
				done: this.uploadJob.processedCount,
				total: this.uploadJob.files.length
			});
		}
	},
	methods: {
		// The file upload component reports a drop or a pick as one start, a
		// file per input and one finished, so the files go up in one request.
		onSelectStart(){
			this.selection = [];
		},
		onFile(file:File){
			if (this.sending) return;
			this.selection.push(file);
		},
		async onSelectFinished(){
			let files = this.selection;
			this.selection = [];
			if (this.sending || !files.length) return;
			if (files.length > MAX_FILES) {
				this.$wf.notify(this.$ct("too-many-files", {max: MAX_FILES}), "warning", 5000, "exclamation-triangle");
				return;
			}
			try{
				await this.uploadJob.start(files);
			}catch(err){
				let hErr = err as HttpError;
				hErr.dontShow = true;
				this.$wf.notify(hErr.getText(), "danger", 5000, "exclamation-triangle");
			}
		},
		// dragenter and dragleave also fire for the children of the tile, so
		// they are counted instead of toggled.
		onDragEnter(){
			this.dragDepth++;
		},
		onDragLeave(){
			this.dragDepth = Math.max(0, this.dragDepth - 1);
		}
	},
	async created(){
		if (!this.showMailAddress) return;
		try{
			this.mailboxAlias = await InboxreaderService.getInboxReaderAlias();
		}catch(err){
			console.error(err);
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.winbox"
	}
});
